import Container from './Container.component';

export default Container;